import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "sonner"
import { currentUrl } from "../../url"

interface Status {
  id: number
  name: string
}

type StatusesState = {
  statuses: Status[]
  loading: boolean
  error: boolean
}

export const fetchStatuses = createAsyncThunk<
  Status[],
  undefined,
  { rejectValue: boolean }
>("statuses/fetchStatuses", async function (_, { rejectWithValue }) {
  try {
    // Читаем токен при каждом вызове, чтобы использовать актуальное значение
    const accessToken = localStorage.getItem("accessToken")
    
    if (!accessToken) {
      return rejectWithValue(false)
    }

    const token = accessToken.startsWith("Bearer ")
      ? accessToken
      : `Bearer ${accessToken}`

    const res = await fetch(`${currentUrl}/master/status`, {
      headers: {
        Authorization: token,
        Accept: "application/json",
      },
    })

    if (!res.ok) {
      if (res.status === 401) {
        localStorage.removeItem("accessToken")
        localStorage.removeItem("refreshToken")
      }
      return rejectWithValue(false)
    }

    const text = await res.text()
    if (!text) {
      return []
    }
    const someData = JSON.parse(text)
    return someData?.data
  } catch (err) {
    console.error("fetchStatuses error:", err)
    // Only show toast if it's not a parsing error, or just suppress it to avoid annoyance on empty bodies
    // toast.error("Ошибка при загрузке данных, попробуйте позже")
    return rejectWithValue(false)
  }
})

const initialState: StatusesState = {
  statuses: [],
  loading: false,
  error: false,
}

const statusesSlice = createSlice({
  name: "statuses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatuses.pending, (state) => {
        state.loading = true
        state.error = false
      })
      .addCase(fetchStatuses.fulfilled, (state, action) => {
        state.statuses = action.payload
        state.loading = false
      })
      .addCase(fetchStatuses.rejected, (state) => {
        state.loading = false
        state.error = true
      })
  },
})

export default statusesSlice.reducer
